import { XMarkIcon } from '@heroicons/react/24/solid';
import { ActionIcon, Box, Flex, Text } from '@mantine/core';

import { ArtistLanguageLevels } from '../../../../@types/types';

const getShortLevel = (level: ArtistLanguageLevels): string => level === ArtistLanguageLevels.Native ? 'Native' : level;

export const ForeignLanguageItem = ({
  name,
  level,
  onRemove
}: {
  name: string;
  level: ArtistLanguageLevels;
  onRemove?: () => void;
}) => (
  <Flex
    align='center'
    gap={0}
    style={{
      border: '1px solid #e9ecef',
      borderRadius: '20px',
      overflow: 'hidden',
      width: '100%'
    }}
  >
    <Box
      px={12}
      py={4}
      style={{ flex: 1, minWidth: 0 }}
    >
      <Text
        fw={500}
        fz={14}
        style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
      >
        {name}
      </Text>
    </Box>
    <Box
      bg='#F74360'
      px={12}
      py={4}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        flexShrink: 0,
        minWidth: onRemove ? '70px' : '50px',
        justifyContent: 'center'
      }}
    >
      <Text c='white' fw={500} fz={14}>
        {getShortLevel(level)}
      </Text>
      {onRemove && (
        <ActionIcon
          size='xs'
          variant='transparent'
          onClick={onRemove}
        >
          <XMarkIcon color='white' width={14} />
        </ActionIcon>
      )}
    </Box>
  </Flex>
);
